import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import ClinicalPopupFields from "./ClinicalPopupFields";
import BillingPopupFields from "./BillingPopupFields";
import vozoLogo from "../../assets/images/vozo-logo-1.png";
import axiosInstance from "../../axios/axios";
import { Encrypt_Value, Decrypt_Value } from "../../MiddleWare/EncryptDecrypt";
import "./Popups.css";

const STEPS = {
  WELCOME: 0,
  CLINICAL: 1,
  BILLING: 2,
};
const getUserId = () => {
  try {
    const encryptedId = localStorage.getItem("user_id");
    if (!encryptedId) return null;
    return Decrypt_Value(encryptedId, "vozo");
  } catch (e) {
    console.error("User ID decrypt failed", e);
    return null;
  }
};
const updateStep1 = async () => {
  const uid = getUserId();
  if (!uid) return;

  try {
    const payload = Encrypt_Value({ uid: uid, step: 1 }, "vozo");

    await axiosInstance.post("/vozo/updatepopupstep", payload);
  } catch (err) {
    console.error("Step 1 update failed", err);
  }
};

const AddClinicalProfile = ({ step, onStepChange, onClose }) => {
  //   const [step, setStep] = useState(STEPS.WELCOME);
  //   const [open, setOpen] = useState(true);

  //   if (!show || !open) return null;
  if (step === null || step === undefined) return null;

  return (
    <Modal
      show
      backdrop="static"
      keyboard={false}
      centered
      className="acp-modal-root"
    >
      <Modal.Body>
        {step === STEPS.WELCOME && (
          <div className="acp-welcome">
            <img src={vozoLogo} alt="VOZO" className="acp-logo" />

            <h2>Welcome to VOZO</h2>
            <p className="acp-subtitle">Your Modern Healthcare Companion</p>

            <div className="acp-feature">
              <div className="acp-icon">👥</div>
              <div>
                <h4>Unified Patient Management</h4>
                <p>
                  All-in-one EHR to manage patients, clinical records, and daily
                  workflows in one place
                </p>
              </div>
            </div>

            <div className="acp-feature">
              <div className="acp-icon">⚡</div>
              <div>
                <h4>Quick Practice Setup</h4>
                <p>
                  Streamlined setup designed to get your practice running
                  quickly
                </p>
              </div>
            </div>

            <div className="acp-feature">
              <div className="acp-icon">📄</div>
              <div>
                <h4>Smart Workflow Tools</h4>
                <p>
                  Built for better care with tools that save time and reduce
                  manual work
                </p>
              </div>
            </div>

            <button
              className="acp-primary-btn"
              onClick={async () => {
                await updateStep1();
                onStepChange(STEPS.CLINICAL);
              }}
            >
              Get Started →
            </button>
          </div>
        )}

        {step === STEPS.CLINICAL && (
          <ClinicalPopupFields
            step={step}
            onSkip={() => onStepChange(STEPS.BILLING)}
            onSuccess={() => onStepChange(STEPS.BILLING)}
          />
        )}

        {step === STEPS.BILLING && (
          <BillingPopupFields
            step={step}
            onFinish={() => {
              onClose();
            }}
          />
        )}
      </Modal.Body>
    </Modal>
  );
};

export default AddClinicalProfile;
